import React, { ReactElement, CSSProperties } from 'react'
import styles from './Tile.module.scss'

export enum TileColor {
    Green
}

interface Props {
    title?: string
    isFullWidth?: boolean
    tileColor?: TileColor
    headerButton?: ReactElement
    headerButtonCondition?: boolean
    scrollable?: boolean
    maxHeight?: number

    multiHeaderButtons?: ReactElement

    children?: React.ReactNode
}

const Tile: React.FC<Props> = ({ title, isFullWidth, children, tileColor, headerButton, headerButtonCondition, scrollable, maxHeight, multiHeaderButtons }) => {
    const colorClass = tileColor !== undefined ?
        tileColor === TileColor.Green ? styles.Tile__colorGreen :
            ''
        : ''

    const showHeaderButton = (headerButtonCondition === true || headerButtonCondition === false) ? headerButtonCondition : true

    const inlineStyles: CSSProperties = scrollable ? { overflowY: "scroll", maxHeight: maxHeight } : {}

    return (
        <div className={`${styles.Tile} ${isFullWidth ? styles.Tile__fullWidth : ''} ${colorClass}`} style={inlineStyles}>
            <div className={`${styles.Tile__header} ${multiHeaderButtons ? styles.Tile__headerMobileFullWidth : ''}`}>{title && <h3 className={styles.Tile__title}>{title}</h3>}{showHeaderButton && headerButton}{showHeaderButton && multiHeaderButtons && <div>{multiHeaderButtons}</div>}</div>
            <div className={styles.Tile__content}>
                {children}
            </div>
        </div>
    )
}

export default Tile
